import { PencilSimpleLine } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import { Button } from "common/components/ui/Button";

export default function AudienceInfo() {
  return (
    <section className="flex items-center gap-x-2 rounded-3xl border border-black-200 p-3">
      <div className="flex flex-col gap-y-0.5">
        <h4 className="text-button-md">Audience</h4>

        <p className="text-xs text-black-500">
          LinkedIn accounts you will target with this campaign
        </p>
      </div>

      <div className="ml-auto flex items-center gap-x-2.5">
        <Button intent="iconOnly" variant="secondary-black" asChild>
          <Link to="./audience">
            <PencilSimpleLine />
          </Link>
        </Button>
      </div>
    </section>
  );
}
